import { render, staticRenderFns } from "./ChatbotEmbedHeader.vue?vue&type=template&id=0cf06c8f&scoped=true&"
import script from "./ChatbotEmbedHeader.vue?vue&type=script&lang=js&"
export * from "./ChatbotEmbedHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotEmbedHeader.vue?vue&type=style&index=0&id=0cf06c8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf06c8f",
  null
  
)

export default component.exports